<template>
  <div class="order-types">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">构建单点、整体、异地三大工单类型体系，覆盖项目细分全场景</div>
      </div>
      <div class="module-body">
        <div class="type-item">
          <img class="type-item-icon" src="@/assets/img/service-provider/OrderTypes/item_icon_ptbz.png">
          <div class="type-item-title">平台标准服务</div>
          <div class="type-item-text">标书撰写</div>
          <div class="type-item-text">工程设计</div>
          <div class="type-item-text">项目现场</div>
          <div class="type-item-text">平台管家</div>
          <div class="type-item-text">......</div>
        </div>
        <div class="type-item">
          <img class="type-item-icon" src="@/assets/img/service-provider/OrderTypes/item_icon_xmwb.png">
          <div class="type-item-title">项目外包服务</div>
          <div class="type-item-text">项目交付</div>
          <div class="type-item-text">软件开发</div>
          <div class="type-item-text">......</div>
        </div>
        <div class="type-item">
          <img class="type-item-icon" src="@/assets/img/service-provider/OrderTypes/item_icon_zczc.png">
          <div class="type-item-title">驻场支持服务</div>
          <div class="type-item-text">维保托管</div>
          <div class="type-item-text">项目常驻</div>
          <div class="type-item-text">安装调试</div>
          <div class="type-item-text">......</div>
        </div>
      </div>
    </div>
    <div class="carousel-container">
      <div class="left-filter"></div>
      <div class="right-filter"></div>
      <div class="carousel-inner">
        <div class="carousel-item" v-for="(item, index) in renderList" :key="index">
          <img class="carousel-item-icon" :src="require(`@/assets/img/service-provider/OrderTypes/carousel_item_${item.id}.png`)">
          <div class="carousel-item-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      carouselList: [
        { id: 'xsbf', name: '销售拜访' },
        { id: 'xqgt', name: '需求沟通' },
        { id: 'jsbzx', name: '技术标撰写' },
        { id: 'swbzx', name: '商务标撰写' },
        { id: 'jjbzx', name: '经济标撰写' },
        { id: 'rkjba', name: '入库及备案' },
        { id: 'tbsb', name: '投标述标' },
        { id: 'gclqd', name: '工程量清单' },
        { id: 'gcsj', name: '工程设计' },
        { id: 'jjfa', name: '解决方案' },
        { id: 'xckc', name: '现场勘察' },
        { id: 'xcbm', name: '现场报名' },
        { id: 'zjscc', name: '建造师出场' },
        { id: 'gjfw', name: '管家服务' },
        { id: 'xmgl', name: '项目管理' },
        { id: 'zlbx', name: '资料编写' },
        { id: 'azts', name: '安装调试' },
        { id: 'sbyw', name: '设备运维' },
        { id: 'pjbl', name: '票据办理' },
        { id: 'cwjz', name: '财务记账' },
        { id: 'spzz', name: '视频制作' },
        { id: 'twsj', name: '图文设计' }
      ],
      renderList: []
    }
  },
  created() {
    this.renderList = this.carouselList.concat(this.carouselList);
  },
};
</script>

<style lang="less" scoped>
.order-types {
  padding: 64px 0;
  background-color: #fff;

  .content-center {
    .module-body {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .type-item {
        width: 402px;
        height: 340px;
        padding-top: 24px;
        background-image: url('@/assets/img/service-provider/OrderTypes/item_background.png');
        background-size: 100% 100%;
        text-align: center;
        .type-item-icon {
          width: 80px;
          height: 80px;
          margin: 0 auto;
        }
        .type-item-title {
          margin-top: 24px;
          font-weight: bold;
        }
        .type-item-text {
          margin-top: 12px;
          font-size: 14px;
        }
      }
    }
  }

  .carousel-container {
    width: 100%;
    margin-top: 64px;
    overflow: hidden;
    position: relative;
    .carousel-inner {
      width: 9328px;
      display: flex;
      animation: roll 60s linear infinite;
      @keyframes roll {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-50%);
        }
      }
      .carousel-item {
        margin-left: 88px;
        cursor: default;
        .carousel-item-icon {
          width: 124px;
          height: 124px;
        }
        .carousel-item-name {
          margin-top: 20px;
          text-align: center;
        }
      }
    }
    .left-filter {
      width: 240px;
      height: 100%;
      background: linear-gradient(90deg, #fff 29.49%, hsla(0, 0%, 100%, 0));
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .right-filter {
      width: 240px;
      height: 100%;
      background: linear-gradient(270deg, #fff 29.49%, hsla(0, 0%, 100%, 0));
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
    }
  }
}
</style>
